import { useContext } from "react";
import { AuthContext } from "@/hooks/auth/AuthContext";
import { useBillingStatus } from "@/domains/billing/BillingStatusContext";
import { clearBuildingSetupDraft } from "@/domains/billing/buildingSetupDraft";
import { Dialog } from "@/components/ui/dialog";
import BuildingForm from "./BuildingForm";

interface NewBuildingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * "Add New Building" as a modal popup over the current page — mirrors the
 * "Create New Project" dialog so the left navigation stays visible instead of
 * the full-page form replacing everything.
 */
export function NewBuildingDialog({ open, onOpenChange }: NewBuildingDialogProps) {
  const userId = useContext(AuthContext)?.userId;
  const { orgId } = useBillingStatus();
  const changeOpen = (next: boolean) => {
    if (!next && orgId) clearBuildingSetupDraft(userId, orgId);
    onOpenChange(next);
  };
  return (
    <Dialog open={open} onOpenChange={changeOpen}>
      {open && (
        <BuildingForm
          isModal
          onCancel={() => changeOpen(false)}
          onSuccess={() => changeOpen(false)}
        />
      )}
    </Dialog>
  );
}

export default NewBuildingDialog;
